import types from './types';
import api from "../api";
import {createError, logError, logSuccess} from "../../../ui/Notify";

function getErrorMessage(errorResponse) {
  if (errorResponse.data && errorResponse.data.errors) {
    return  errorResponse.data.errors.map(({message}) => message).join(", ");
  }
  return errorResponse;
}

function requestAnswerList() {
  return {
    type: types.GET_ANSWERS_BY_SESSION_REQUEST,
    isFetchingAnswers: true
  };
}

function requestAnswerListCompleted(answers) {
  return {
    type: types.GET_ANSWERS_BY_SESSION_COMPLETED,
    isFetchingAnswers: false,
    answers
  };
}

function requestAnswerListError(answersError) {
  return {
    type: types.GET_ANSWERS_BY_SESSION_ERROR,
    isFetchingAnswers: false,
    answersError
  };
}

export function getAnswers(id) {
  return dispatch => {
    dispatch(requestAnswerList());
    return api.getSessionAnswers(id)
      .then(response => {
        if (response.status === 200) {
          let resp = response.data;
          dispatch(requestAnswerListCompleted(resp));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = getErrorMessage(err.response);
          logError(message);
          dispatch(requestAnswerListError(message));
        } else {
          logError(err);
          dispatch(requestAnswerListError(createError("Не удалось загрузить список ответов")));
        }
      });
  };
}

export default {
  getAnswers
};
